import FO3 from './FO3';
import FO4 from './FO4';
import FO6 from './FO6';
import FO2 from './FO2';
import FO1 from './FO1';
import { InlandMarineRisk } from './inland-marine-risk';

export const riskTypes = {
  FO3,
  FO4,
  FO6Structures: FO6,
  FO2,
  FO1,
  // #33164: standalone inland marine renders inline in the location's risk list like the dwelling
  // cards, and is added through the normal add-risk dropdown. FO-6 scheduled/unscheduled are
  // deliberately absent from this map — FarmingEquipment renders those from their own buttons.
  InlandMarine: InlandMarineRisk
};
